import { LANGUAGE_CODES, pickLanguage } from "@szerviz/i18n";

const STORAGE_KEY = "szerviz.language";

/** The language the user chose on this device, or null. */
export function savedLanguage(): string | null {
  try {
    const saved = globalThis.localStorage?.getItem(STORAGE_KEY);
    return saved && LANGUAGE_CODES.includes(saved) ? saved : null;
  } catch {
    return null;
  }
}

/** Saved choice first, then the operating system / browser languages. */
export function initialLanguage(): string {
  try {
    const saved = globalThis.localStorage?.getItem(STORAGE_KEY);
    if (saved && LANGUAGE_CODES.includes(saved)) return saved;
  } catch {
    // storage unavailable (private mode): fall through
  }
  const nav = globalThis.navigator;
  return pickLanguage(nav?.languages ?? (nav?.language ? [nav.language] : []));
}

export function saveLanguage(code: string): void {
  try {
    globalThis.localStorage?.setItem(STORAGE_KEY, code);
  } catch {
    // ignore: the choice then lasts for this session only
  }
}
